angular.module('NumbersEditor')
    .controller('GameEditController', [
        '$scope', 'GameFactory', 'appInfoFactory', '$location', '$rootScope', '$routeParams', '$dialogs', '$document', 'gameService',
        function ($scope, gameFactory, appInfoFactory, $location, $rootScope, $routeParams, $dialogs, $document, gameService) {

            init();

            function init() {
                $rootScope.SetAppTitle("Edit Game", "Edit Game");
                getGame();
                setMinMaxDates();
            };

            function getGame() {
                gameService.getGame($routeParams.gameId, $routeParams.sportCode, $routeParams.startDate)
                    .then(function (game) {
                        game.StartDate = new Date(game.StartDate);
                        $scope.GameEdit = game;
                        gameService.setDatePicker($scope);
                    })
                    .catch(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            function setMinMaxDates() {
                appInfoFactory.getDateTime()
                    .success(function (dateTime) {
                        var today = new Date(JSON.parse(dateTime));
                        var maxDate = new Date(today.setMonth(today.getMonth() + 3));
                        $scope.maxDate = new Date(maxDate.setDate(today.getDate() - 1));
                    }).error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            }

            $scope.SaveGameEdit = function () {
                var game = $scope.GameEdit;
                var eDate = new Date(game.StartDate);
                eDate.setHours("12");
                game.StartDate = eDate;

                gameFactory.saveGame(game)
                    .success(function () {
                        $.message(MessageText.GameSuccessfullySaved, MessageType.Success);
                        $location.path('game/' + $routeParams.gameId.toString()).search({ sportCode: $scope.GameEdit.SportCode.toString(), startDate: $scope.GameEdit.StartDate.toISOString() });
                    })
                    .error(function (error) {
                        $.message(error.Message, MessageType.Error);
                    });
            };

            $scope.CancelGameEdit = function () {
                $location.path('game/' + $routeParams.gameId.toString()).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate });
            };

            $scope.$watch('GameEdit.StartDate', function () {
                $scope.opened = false;
            });

            $document.bind('keypress', function ($event) {
                if ($event.which === 13) {
                    $("#btnstartdate").click();
                }
            });

            // disabled the Christmas day in the calendar
            $scope.disabled = function (date, mode) {
                if (date.getMonth() == 11 && date.getDate() == "25") return true;
                else return false;

            };

            $scope.closemodal = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = false;
            };

            $scope.open = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = true;
            };
        }
    ]);